/* eslint-disable */
export default {
  copy: '复制',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
